import { Component, OnInit, ViewEncapsulation } from '@angular/core';


@Component({
    selector: 'app-scroll-to-top',
    templateUrl: './scroll-to-top.component.html',
    styleUrls: ['./scroll-to-top.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ScrollToTopComponent implements OnInit {

  constructor() { }

  scrolltoTop() {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
  }

}
